module.exports = __webpack_public_path__ + "static/img/banner_new.19369af.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/banner/banner_new.jpg
// module id = CegE
// module chunks = 15